import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"stacked-bar-chart-2, revenue"} maskId="square-filled-radius-0-stroke-1-IconStackedBarChart2"><path d="M22 20H2V19H4V11H7V19H8V6H11V19H13V9H16V19H17V4H20V19H22V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStackedBarChart2;
